import React, { useEffect, useState } from "react";
import { Row, Col, Dropdown, Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as SettingsStyles from "../styles/settings";

function Settings() {
    const dispatch = useDispatch();

    const [settings, setSettings] = useState({
        footerText: "",
        frontLayout: ""
    });

    const frontLayoutItems = [
        { code: "mixedItems", text: "Mixed Items" },
        { code: "byCategory", text: "By Category" }
    ];

    const [footerButtonColour, setFooterButtonColour] = useState("primary");
    const [frontLayoutButtonColour, setFrontLayoutButtonColour] = useState("primary");

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service - Orders"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));

        const data = { end: "admin" };
        Axios.post("/pods/3dPrintingShop/settings/load", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setSettings({
                        footerText: data.settings.footer,
                        frontLayout: data.settings.frontLayout
                    });
                }
            })
            .catch((err) => console.log(err));
    }, []);

    function handleFooterTextChange(event) {
        const { value } = event.target;

        setSettings((prevState) => {
            return { ...prevState, footerText: value };
        });
    }

    function handleFooterUpdate() {
        const data = { footerText: settings.footerText };
        Axios.post("/pods/3dPrintingShop/settings/updateFooter", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setFooterButtonColour("success");

                    setTimeout(() => {
                        setFooterButtonColour("primary");
                    }, 1000);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleFrontLayoutSelection(code) {
        const data = { code: code };
        Axios.post("/pods/3dPrintingShop/settings/updateFrontLayout", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setSettings((prevState) => {
                        return { ...prevState, frontLayout: code };
                    });
                    setFrontLayoutButtonColour("success");

                    setTimeout(() => {
                        setFrontLayoutButtonColour("primary");
                    }, 1000);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={SettingsStyles.body}>
            <Row>
                <Col>
                    <h3>
                        <strong>Shop Front</strong>
                    </h3>
                    <div style={SettingsStyles.layoutContainer}>
                        Layout:
                        {settings.frontLayout != "" && (
                            <Dropdown>
                                <Dropdown.Toggle variant={frontLayoutButtonColour}>
                                    {frontLayoutItems.find((item) => item.code == settings.frontLayout).text}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {frontLayoutItems.map((item, index) => {
                                        return (
                                            <Dropdown.Item key={index} onClick={handleFrontLayoutSelection.bind(this, item.code)}>
                                                {item.text}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                </Col>
                <Col>
                    <h3>
                        <strong>Footer</strong>
                    </h3>
                    <Form.Control as="textarea" rows={3} value={settings.footerText} onChange={handleFooterTextChange} />
                    <div style={SettingsStyles.columnRight}>
                        <Button variant={footerButtonColour} onClick={handleFooterUpdate}>
                            Update
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default Settings;
